import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { showMegaDropdown, hideMegaDropdown } from '../mega-dropdown';
import { changedSizeBetweenMobileAndDesktop, isPad } from '../../utilities/detection';
import { lockScrollbar, unlockScrollbar } from '../../utilities/scroll-helper';

import { getStickyOffset } from '../../utilities/scroll-helper';
import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

import { ComponentRef } from '@opten/compiler/metadata/di';
import { Navbar } from './navbar';

// const mouseEnterDuration = 300;

// todo: update arias also in dekstop e.g. for mega-dropdown
@Component({ className: 'js-navbar-mega-dropdown-toggler' })
export class NavbarMegaDropdown implements OnInit {
    private _backdropElement: HTMLElement;
    private _dropdownElement: HTMLElement;
    private _dropdownElements: Array<HTMLElement>;
    private _currentWindowWidth: number;
    @ComponentRef(Navbar) _navbar: Navbar;


    get _isOpen(): boolean {
        return hasClass(this._dropdownElement, '--show');
    }

    // used to know if we're still animating
    // private _timeout: number | null = null;

    // private _boundShow = this._handleShow.bind(this);
    // private _boundHide = this._handleHide.bind(this);

    constructor(private element: HTMLElement) {
        this._backdropElement = document.getElementsByClassName(
            'js-navbar-backdrop'
        )[0] as HTMLElement;

        this._dropdownElement = element.parentElement.getElementsByClassName(
            'js-navbar-mega-dropdown'
        )[0] as HTMLElement;

        this._dropdownElements = Array.from(
            document.getElementsByClassName('js-navbar-mega-dropdown')
        ) as Array<HTMLElement>;
    }

    onInit() {
        this._handleResize();
        window.addEventListener('resize', () => this._handleResize());
    }

    private _addDesktopListeners() {
        this.element.addEventListener('click', this._handleClick);
        this._backdropElement.addEventListener(
            'click',
            this._handleBackdropClick
        );
        // this.element.addEventListener('mouseenter', this._boundShow);
        // this.element.addEventListener('mouseleave', this._boundHide);

    }

    private _removeDesktopListener() {
        if (isPad()) {
            this.element.removeEventListener('click', this._handleClick);
            this._backdropElement.removeEventListener(
                'click',
                this._handleBackdropClick
            );
            // this.element.removeEventListener('mouseenter', this._boundShow);
            // this.element.removeEventListener('mouseleave', this._boundHide);
        }
    }

    private _setContainerHeight() {
        const container = this._dropdownElement
            .firstElementChild as HTMLElement;

        const stickyOffset = getStickyOffset();
        if (container && stickyOffset) {
            container.style.maxHeight = `calc(100vh - ${stickyOffset}px)`;
        }
    }

    private _setDropdownPosition() {
        this._dropdownElement.style.marginLeft = "0px";
        if (isPad() == false) {
            const dropdownBox = this._dropdownElement.getBoundingClientRect();
            const spacerRight = 40;
            if (dropdownBox.right > (window.innerWidth - spacerRight)) {
                this._dropdownElement.style.marginLeft = "-" + ((dropdownBox.left + dropdownBox.width) - (window.innerWidth - spacerRight)) + "px";
            }
        }

    }

    private _handleResize() {
        const wasOpen = this._isOpen !== false;
        const oldWindowWidth = this._currentWindowWidth ? parseInt(this._currentWindowWidth.toString(), 10) : window.innerWidth;
        const resizedBetweenMobileAndDesktop = changedSizeBetweenMobileAndDesktop(oldWindowWidth);
        this._currentWindowWidth = window.innerWidth;

        this.hide();
        if (isPad()) {
            this._dropdownElement.style.marginLeft = "0px";
        }

        if (isPad() && hasClass(this.element, 'js-favorite-shortcut-chooser') == false) {
            this._removeDesktopListener();
        } else {
            this._setContainerHeight();
            this._addDesktopListeners();
            this._setDropdownPosition();
        }
        if (wasOpen && resizedBetweenMobileAndDesktop === false) {
            this.show();
        }
    }

    public toggle() {
        this._isOpen ? this.hide() : this.show();
    }

    public show() {
        if (this._isOpen) {
            return;
        }

            addClass(this._navbar.navbarElement, '--mega-dropdown--open');
            addClass(this._navbar._header,'has--mega-dropdown--open');

            // check if another one is open, to hide it except the backdrop
            // const anyOpen =
            //     this._dropdownElements.map(dropdown => hasClass(dropdown, '--show'))
            //         .length > 0;

            this._dropdownElements.forEach(dropdown => {
                if (hasClass(dropdown, '--show')) {
                    hideMegaDropdown(dropdown);
                }

                // nicer animation because we already have one open!
                //dropdown.style.transition = anyOpen ? 'none' : null;
            });

            showMegaDropdown(this._dropdownElement, this._backdropElement);
    }

    public hide() {
        if (!this._isOpen) {
            return;
        }
        removeClass(this._navbar.navbarElement, '--mega-dropdown--open');
        removeClass(this._navbar._header,'has--mega-dropdown--open');

        hideMegaDropdown(this._dropdownElement, this._backdropElement);
    }

    private _handleClick = (event: MouseEvent) => {
        event.preventDefault();

        this.toggle();
    }

    private _handleBackdropClick = (event: MouseEvent) => {
        event.preventDefault();

        this.hide();
    }

    /*private _handleShow(event: MouseEvent) {
        // add an delay so we don't show it directly when the user
        // hover over the link
        if (this._timeout != null) {
            // don't do anything if we still animating
            return;
        }

        const animate = !this._dropdownElement.style.transition;

        if (animate) {
            this._timeout = setTimeout(
                () =>
                    showMegaDropdown(
                        this._dropdownElement,
                        this._backdropElement
                    ),
                mouseEnterDuration
            );
        } else {
            showMegaDropdown(this._dropdownElement, this._backdropElement);
        }

        // close the search so we don't have to handle the backdrop
        // by re-adding it if the search is open...
        if (this._search) {
            this._search.close();
        }
    }

    private _handleHide(event: MouseEvent) {
        const toElement = (event.relatedTarget ||
            event.toElement) as HTMLElement;

        // nicer animation, if we go over an other element
        // we just hide it instead of animate it
        if (
            !toElement ||
            !isAncestorOfClass(
                toElement,
                'js-navbar-mega-dropdown-toggler',
                true
            )
        ) {
            this._dropdownElements.forEach(
                dropdown => (dropdown.style.transition = null)
            );
        } else {
            this._dropdownElements.forEach(
                dropdown => (dropdown.style.transition = 'none')
            );
        }

        this.hide();

        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
    }*/
}
